import React, { useDeferredValue, useEffect, useState } from 'react';
import { useToaster, Message } from 'rsuite';
import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'
import { transliterate as tr, slugify } from 'transliteration';

import PN from "persian-number";



export function APIKey() {
    return "1cb5ba74-9d4f-4217-b35c-f00355a2b3ab";
}

// utils/slug.js
export function toSlug(text, opts = { latin: false }) {
    if (!text && text !== 0) return "";


    let s = String(text).normalize('NFKC').trim();

    // استانداردسازی حرف‌های فارسی: ي -> ی ، ك -> ک
    s = s.replace(/ي/g, "ی").replace(/ك/g, "ک");

    // حذف اعراب و حروف کمکی عربی/فارسی
    s = s.replace(/[\u064B-\u065F\u0610-\u061A\u06D6-\u06ED]/g, "");

    // حذف گیومه‌ها و علائم خاص (به جز پرانتزها)
    s = s.replace(/[«»“”"'[\]{}]/g, "");

    // 🔹 تبدیل پرانتز باز به خط تیره، و حذف پرانتز بسته
    s = s.replace(/\(/g, "-").replace(/\)/g, "");

    // حذف کاراکترهای کنترلی و نیم‌فاصله (ZWNJ)
    s = s.replace(/\u200c/g, "");

    // همه اسلش‌ها، بک‌اسلش، و علامت‌های جداکننده → فاصله
    s = s.replace(/[\/\\\|_+=:,؛،.]/g, " ");

    s = s.replace(/ـ/g, "-");
    // چند فاصلهٔ پی‌در‌پی → خط تیره
    s = s.replace(/\s+/g, "-");

    // حذف هر کاراکتر غیرمجاز (فقط فارسی، لاتین، عدد، و خط‌تیره مجاز است)
    s = s.replace(/[^ء-ۿA-Za-z0-9\-]/g, "");

    // پاک‌سازی خط تیره‌های تکراری و ابتدا/انتهای رشته
    s = s.replace(/-+/g, "-").replace(/^-+|-+$/g, "");
    // به حروف کوچک تبدیل کن
    s = s.toLowerCase();

    // اگر خواستی خروجی لاتین باشه (transliteration)، از پکیج transliteration استفاده کن
    if (opts.latin) {

        // این بلاک فقط وقتی opts.latin=true استفاده کن که پکیج نصب باشه
        try {


            // ابتدا کلیدهای دیکشنری را بر اساس طول مرتب کن (عبارات طولانی‌تر اول)
            const keys = Object.keys(wordDictionary).sort((a, b) => b.length - a.length);

            // let result = "";
            console.dir(s)
            console.dir(keys)
            keys.forEach((key) => {
                s = s.replace(key, wordDictionary[key]);
                console.dir("inner " + s.replace(key, wordDictionary[key]))

            });
            console.dir("Outer " + s)


            const words = s.split("-").filter(Boolean);
            // console.dir(words);
            var FinalWord = "";
            // 🔸 مرحله ۲: ترجمه هر کلمه با دیکشنری (در صورت نبود → transliteration حرفی)
            words.map((word) => {

                FinalWord = FinalWord + " " + transliterateWord(word);
            });
            console.dir("FinalWord " + FinalWord);
            FinalWord = FinalWord.replace(/\s+/g, "-").toLowerCase();

            const parts = FinalWord.split("-");

            const uniqueParts = [...new Set(parts)];
            s = uniqueParts.join("-");
            // پاک‌سازی خط تیره‌های تکراری و ابتدا/انتهای رشته
            s = s.replace(/-+/g, "-").replace(/^-+|-+$/g, "");
            console.dir(s)
            return s;

            // 🔸 مرحله ۳: ساخت slug نهایی
        } catch (e) {
            // اگر transliteration نصب نبود، برگرد همون s
            return s;
        }
    }

    return s;
}


export const wordDictionary = {
    // 🔌 موتور برق و ژنراتور
    "موتور-برق": "generator",
    "موتوربرق": "generator",
    "ژنراتور": "generator",
    "پاور": "power",
    "استیشن": "station",
    "سان": "Sun",
    "لیتیومی": "lithium",
    "لیتیوم": "lithium",
    "با-باتری": "battery",

    "بنزینی": "gasoline",
    "گازوئیلی": "diesel",
    "دیزل": "diesel",
    "دیزلی": "diesel",
    "گازی": "gas-powered",
    "گازسوز": "gas-powered",
    "بی‌صدا": "silent",
    "قابل‌حمل": "portable",
    "تکفاز": "single-phase",
    "فاز": "single",
    "سه‌فاز": "three-phase",
    "سه‌-فاز": "three-phase",
    "فاز": "three",
    "فاز": "phase",
    "اتوماتیک": "automatic",
    "هندلی": "manual",
    "دستی": "manual",
    "استارتی": "electric-start",
    "موتور": "engine",

    // 💧 پمپ آب و تجهیزات آبیاری
    "پمپ": "pump",
    "پمپ-آب": "water-pump",
    "آب": "water",
    "پمپ-سمپاش": "sprayer-pump",
    "پمپ-کفکش": "submersible-pump",
    "پمپ-کف-کش": "submersible-pump",
    "پمپ-لجن‌-کش": "sewage-pump",
    "لجن‌-کش": "sewage",
    "لجنکش": "sewage",
    "پمپ-لجنکش": "sewage-pump",
    "سمپاش": "sprayer",
    "مه‌پاش": "fogger",
    "مه‌-پاش": "fogger",
    "تانکر": "tank",
    "مخزن": "tank",
    "لانسی": "lance",
    "پشتی": "backpack",
    "لانس": "lance",
    "خرطومی": "hose",
    "شیلنگ": "hose",
    "کارواش": "pressure-washer",
    "خانگی": "home",
    "شیلنگ-دار": "with-hose",
    "شیلنگدار": "with-hose",
    "شیلنگ‌دار": "with-hose",

    // 🌿 ابزار کشاورزی
    "علفتراش": "brush-cutter",
    "علف-تراش": "brush-cutter",
    "علف-زن": "brush-cutter",
    "شمشادزن": "hedge-trimmer",
    "شمشاد-زن": "hedge-trimmer",
    "اره": "saw",
    "اره-زنجیری": "chain-saw",
    "اره-شارژی": "cordless-saw",
    "اره-برقی": "electric-saw",
    "اره-بنزینی": "gasoline-saw",
    "تیغه": "blade",
    "کاتر": "cutter",
    "تراکتور": "tractor",
    "تراکتوری": "tractor",
    "الکتروموتور": "electromotor",
    "کلاغ-پران": "bird-scarer",
    "کلاغ-پرون": "bird-scarer",
    "چاله‌کن": "earth-auger",
    "چاله-کن": "earth-auger",
    "زنبه-ای": "zambehi",
    "زنبه‌ای": "zambehi",
    "زمبه-ای": "zambehi",
    "زمبه‌ای": "zambehi",
    "پراتابل": "portable",

    "تیلر": "tiler",
    "کولتیواتور": "cultivator",
    "کلتیواتور": "cultivator",

    // ⚙️ موتور و برندها
    "هوندا": "honda",
    "روبین": "robin",
    "لوبن": "luben",
    "ویما": "veema",
    "تک": "single",
    "دو": "double",
    "چهار": "four",
    "اسب": "hp",
    "وات": "watt",
    "کیلووات": "kw",

    // 🔩 ابزار صنعتی
    "دریل": "drill",
    "بتن‌کن": "hammer-drill",
    "بتنکن": "hammer-drill",
    "بتن‌-کن": "hammer-drill",
    "سشوارصنعتی": "heat-gun",
    "سشوار-صنعتی": "heat-gun",
    "فرز": "grinder",
    "بکس": "impact-wrench",

    // 🧰 متفرقه
    "شارژی": "cordless",
    "برقی": "electric",
    "صنعتی": "industrial",
    "خانگی": "home",
    "سنگین": "heavy-duty",
    "سبک": "light-duty",
    "خودرو": "vehicle",
    "ژنراتور-برق": "power-generator",
    "ژنراتوربرق": "power-generator",
    "مولدبرق": "generator",
    "مولد-برق": "generator",
    // حروف ربط
    "و": "and",
    "یا": "or",
    "کیلووات ": "kw",
    "کیلو وات ": "kw",
    "وات": "w",
    "لیتر": "liter",
    "لیتری": "liter",
    "اتومایزر": "atomizer",
    "مدل": "model",
};


function transliterateWord(word) {
    console.dir(word)


    const map = {
        "ا": "a", "آ": "a", "ب": "b", "پ": "p", "ت": "t", "ث": "s", "ج": "j",
        "ح": "h", "د": "d", "ذ": "z", "ر": "r", "ز": "z", "س": "s", "ش": "sh",
        "ع": "a", "ف": "f", "ک": "k", "گ": "g", "ل": "l", "م": "m", "ن": "n",
        "و": "o", "ه": "h", "ی": "i",
        "چ": "ch", "ش": "sh", "ژ": "zh", "خ": "kh",
        "غ": "gh", "ق": "gh", "ص": "s", "ض": "z",
        "ط": "t", "ظ": "z"
    };



    // جایگزینی تک‌حرفی‌ها
    let out = "";
    for (let ch of word) {
        out += map[ch] || "";
    }

    return out == "" ? word : out;//|| word;
}





export function ApiRoute() {
   // return "http://localhost:51391/api";
     return "https://api.farmasan.ir/api";
}

export function SiteRoute() {
    return "https://farmasan.ir/";
}


export function ApiPhotoRoute() {
    //  return "http://localhost:51391/";
    return "https://api.farmasan.ir/";
}

export function customOptionsFilterMethod(filter, row) {

    if (filter.value != "")
        return (row[filter.id].toString().toLowerCase().toPersianDigit().includes(filter.value.toString().toLowerCase().toPersianDigit()));
    else
        return (row[filter.id].toLowerCase().includes(filter.value.toLowerCase()));
}


export function GuidEmpty() {
    return "00000000-0000-0000-0000-000000000000";
}



export function ShowMessage(type, msg) {
    return (
        <Message showIcon type={type} closable>
            {msg}
        </Message>
    )
}


export const SuccessMessage = (Result) => {
    return (
        "داده ها با موفقیت " + Result
    )
}


export const ErrorMessage = (Result) => {
    if (String(Result) === "AccessDenied") {
        return ("دسترسی غیر مجاز ، لطفا با مدیر سیستم تماس بگیرید!");
    }
    else if (String(Result) === "InvalidApiKey") {
        return ("دسترسی غیر مجاز ، لطفا با مدیر سیستم تماس بگیرید!");
    }
    else {
        return (
            "خطای نامشخص ، شرح خطا    : " + Result
        )
    }
}



// export function EMoneySeperate(value) {
//     if (value == "0")
//         return "0";

//     var finalPrice = "";
//     var currentvalue = "";
//     currentvalue = String(value).replace(/,/g, '');

//     var j = 0;
//     for (var i = currentvalue.length; i > 0; i--) {

//         finalPrice = currentvalue[i - 1] + finalPrice;
//         j++;
//         if (j === 3 && i !== 1) {
//             finalPrice = ',' + finalPrice;
//             j = 0;
//         }
//     }
//     return finalPrice;

// }

